module.exports = __webpack_public_path__ + "static/media/2012 - 2013 theme logo.488e9a94.jpg";